import React, { useEffect, useState } from "react";
import {
  Button,
  Link,
  IconButton,
  Modal,
  Tooltip,
  InputLabel,
  CircularProgress,
  Typography,
  Card,
  Grid,
  CardContent,
  Select,
  MenuItem,
  TextField,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Alert,
  AlertTitle,
  Stepper,
  Step,
  StepLabel,
  Box,
  Backdrop,
  Switch,
} from "@mui/material";
import Autocomplete, { createFilterOptions } from "@mui/material/Autocomplete";
import InputAdornment from "@mui/material/InputAdornment";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { Theme, useTheme } from "@mui/material/styles";
import { createStyles, makeStyles } from "@mui/styles";
import { checkForRole } from "../../utils/GetAuth";
import { useLocalStorage } from "../../utils/LocalStorageHook";
import requestMissingContexts, {
  determineConfig,
  determineConfigLong,
  displayConfig,
  getRequestStatus,
} from "../../utils/GetContext";
import TableAbstraction from "../../componentUtils/TableAbstraction";
import LockIcon from "@mui/icons-material/Lock";
import AddIcon from "@mui/icons-material/Add";
import UndoIcon from "@mui/icons-material/Undo";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import CloseIcon from "@mui/icons-material/Close";
import GetApp from "@mui/icons-material/GetApp";
import Attachment from "@mui/icons-material/Attachment";
import Publish from "@mui/icons-material/Publish";
import RocketIcon from "@mui/icons-material/RocketLaunch";
import MoneyOffIcon from "@mui/icons-material/MoneyOff";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import PriceCheckIcon from "@mui/icons-material/PriceCheck";
import { formatDate, formatDateTime, getUniqueStringList } from "../../utils/Formatter";

import {
  getMaterialsForPriceGroups,
  getPriceChangePriceGroupsList,
  getCustomerGroupList,
  getReviewSimulationData,
  SubmitReviewDataForApproval,
  priceChangeRequestData,
  handleApproval,
} from "../../utils/RemotePriceManagement";
import { downloadPriceRequestCSV } from "../../utils/RemotePriceManagement";
import _ from "lodash";

function getModalStyle() {
  const top = 50;
  const left = 50;

  return {
    top: `${top}%`,
    left: `${left}%`,
    transform: `translate(-${top}%, -${left}%)`,
  };
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    centerDiv: {
      textAlign: "center",
    },
    root: {},
    divWidth: {
      width: "100%",
    },
    gridSpaceable: {
      padding: theme.spacing(2),
    },
    gridMarginTop: {
      marginTop: theme.spacing(2),
    },
    modal: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    modalGrid: {
      marginTop: theme.spacing(2),
    },
    modalTitle: {
      color: theme.palette.primary.main,
    },
    modalCard: {},
    modalText: {},
    modalInput: {
      width: "350px",
    },
    paper: {
      position: "absolute",
      backgroundColor: theme.palette.background.paper,
      border: `1px solid`,
      borderColor: theme.palette.border.main,
      boxShadow: theme.shadows[4],
      padding: theme.spacing(2, 2, 2),
    },
    paragraphButton: {
      marginLeft: theme.spacing(2),
      minWidth: 160,
    },
  })
);
interface TableRow {
  editRowCustGroupName: any;
  editedRowPriceGroup: any;
  rowMaterial: any;
  editedRowStartDate: string;
  editedRowScheduleType: string;
  editedRowVendPrice: string;
}

export default function PriceChangeRequests() {
  const classes = useStyles();
  const [priceChangeRequestsData, setPriceChangeRequestsData] = useState<any[]>([]);
  const [codes, setCodes] = React.useState<any>();
  const [salesOrg] = useLocalStorage("SETTINGS.salesOrg", "");
  const [priceGroupData, setPriceGroupData] = useState<any[]>([]);
  const [customerGroupData, setCustomerGroupData] = useState<any[]>([]);
  const [priceGroupMatrialList, setPriceGroupMatrialList] = useState<any[]>([]);
  const allOption = { material_num: "ALL", description: "ALL" };
  const materialOptions = [allOption, ...priceGroupMatrialList];
  const [doneLoading, setDoneLoading] = React.useState<boolean>();
  const [clientId] = useLocalStorage("SETTINGS.clientId", "100");
  const enabled = checkForRole(clientId, salesOrg, "vp_admin");
  const [muiTable, setMuiTable] = React.useState<any>({ rpp: 25 });
  const [useCompact] = useLocalStorage("SETTINGS.compact", true);
  const [confirmDelete, setConfirmDelete] = React.useState<boolean>(false);

  const [editRowCustGroupName, setEditRowCustGroupName] = useState<any>({
    customer_num: null,
  });
  const [editedRowPriceGroup, setEditedRowPriceGroup] = useState<any>({
    group_name: null,
  });
  const [rowMaterial, setRowMaterial] = useState({ material_num: allOption });
  const [editedRowVendPrice, setEditedRowVendPrice] = React.useState<string>("");
  const [editedRowStartDate, setEditedRowStartDate] = useState<Date>(new Date());
  const [editedRowScheduleType, setEditedRowScheduleType] = React.useState<string>("Fill Key");

  const [selectedFile, setSelectedFile] = React.useState<File>();
  const [fileName, setfileName] = React.useState<string>();

  const [records, setRecords] = useState<TableRow[]>([]);
  const [activeStep, setActiveStep] = useState(0);
  const [comingSoonPopup, setComingSoonPopup] = React.useState<boolean>(false);
  const [openEditWindow, setOpenEditWindow] = React.useState(false);
  const [simulationData, setSimulationData] = useState([]);
  const [orignalSimulationData, setOrignalSimulationData] = useState([]);
  const [backdropLoader, setBackdropLoader] = React.useState<boolean>(false);
  const [dynamicColsForReqDetls, setDynamicColsForReqDetls] = React.useState<any>();
  const [requestDetailsPopupData, setRequestDetailsPopupData] = useState<any[]>([]);
  const [openReqDetailsPopup, setOpenReqDetailsPopup] = React.useState(false);
  const [modalStyle] = React.useState(getModalStyle);
  const [dynamicValforApproval, setDynamicValforApproval] = React.useState<string>("");
  const [approvalHeader, setApprovalHeader] = React.useState<string>("");
  const [reqStatus, setRequestStatus] = React.useState<string>("");
  const [isCustBelongToPG, setIsCustBelongToPG] = useState<boolean>(false);
  const [isCustBelongToPGMessage, setIsCustBelongToPGMessage] = useState<String>("");
  const [trackToggle, setTrackToggle] = useState<boolean>(true);
  const [rejectMessage, setRejectMessage] = React.useState<string>("");
  const [rejectPopup, setRejectPopup] = useState<boolean>(false);
  const [commonAlert, setCommonAlert] = useState<any>({
    alertTitle: "",
    alertMessage: "",
    alertProceedButton: false,
    alertDenyButton: false,
    alertDisable: false,
    isAlertOpen: false,
  });
  const steps = ["Create Price change Request & Review ", "Simulation & Submit for Approval"];

  const handleNext = (step: any) => {
    if (step === "proceed_to_review") {
      setBackdropLoader(true);
      const customers = [...new Set(records.map((item) => item.editRowCustGroupName))];
      const priceGroups = [...new Set(records.map((item) => item.editedRowPriceGroup))];
      // Build error map first
      const errorMap = new Map<string, string>();
      records.forEach((record: any) => {
        const matchingRecords = records.filter(
          (r: any) =>
            r.editRowCustGroupName === record.editRowCustGroupName &&
            r.editedRowPriceGroup === record.editedRowPriceGroup &&
            r.rowMaterial === record.rowMaterial
        );

        const uniquePrices = [...new Set(matchingRecords.map((r: any) => r.editedRowVendPrice))];

        if (uniquePrices.length > 1) {
          errorMap.set(
            `${record.editRowCustGroupName}|${record.editedRowPriceGroup}`,
            `Customer ${record.editRowCustGroupName} belongs to same price group ${
              record.editedRowPriceGroup
            } with multiple prices (${uniquePrices.join(", ")})`
          );
        }
      });
      getReviewSimulationData(salesOrg, customers, priceGroups).then((simulationData) => {
        if (simulationData) {
          const { respGroupMaterials, respCustomerMaterials }: any = simulationData;
          //const customerMaterials: string[] = respCustomerMaterials.map((ele: any)=> ele.material_num);
          const updatedSimulationData: any = respGroupMaterials.map((ele: any) => {
            ele.customer_num = "";
            ele.equipment_num = "";
            ele.price = "";
            ele.dex_price = "";
            ele.col_num = "";
            ele.btn_num = "";
            ele.cust_group_name = "";
            ele.price_group_name = ele.groupname;
            const foundMatInCustMat: any = respCustomerMaterials.find(
              (item: any) => item.material_num == ele.material_num
            );
            if (foundMatInCustMat) {
              ele.customer_num = foundMatInCustMat?.customer_num;
              ele.equipment_num = foundMatInCustMat?.equipment_num;
              ele.price = foundMatInCustMat?.price;
              ele.dex_price = foundMatInCustMat?.dex_price;
              ele.col_num = foundMatInCustMat?.col_num;
              ele.btn_num = foundMatInCustMat?.btn_num;
              ele.cust_group_name = foundMatInCustMat?.cust_group_name;
            }
            //
            // Material specific rule takes precedence
            const materialRule = records.find(
              (rec: any) =>
                (rec.editRowCustGroupName === ele.customer_num || rec.editRowCustGroupName === ele.cust_group_name) &&
                (rec.editedRowPriceGroup === ele.price_group_name ||
                  rec.editedRowPriceGroup === ele.price_group_name) &&
                rec.rowMaterial === ele.material_num
            );

            // Fallback to ALL rule
            const allRule = records.find(
              (rec: any) =>
                (rec.editRowCustGroupName === ele.customer_num ||
                  rec.editRowCustGroupName === ele.customer_num ||
                  rec.editRowCustGroupName === ele.cust_group_name) &&
                (rec.editedRowPriceGroup === ele.price_group_name ||
                  rec.editedRowPriceGroup === ele.price_group_name) &&
                rec.rowMaterial === "ALL"
            );

            //judt find vendprice for customer, cutomer_group and price group
            const showVendPrice: any = records.find(
              (rec: any) =>
                rec.editedRowPriceGroup === ele.price_group_name || rec.editedRowPriceGroup === ele.price_group_name
            );
            const matchingRecord = materialRule || allRule;
            const errorDetails = errorMap.get(`${ele.customer_num}|${ele.price_group_name}`) || "";

            return {
              ...ele,
              price_group: matchingRecord?.editedRowPriceGroup ?? ele.price_group_name,
              price_proposed: matchingRecord?.editedRowVendPrice ?? showVendPrice.editedRowVendPrice,
              price_update_on_fill: matchingRecord?.editedRowScheduleType ?? null,
              price_validdate: matchingRecord?.editedRowStartDate ?? null,
              errorDetails,
              isPriceChangeApplied: matchingRecord === undefined ? false : true,
            };
          });

          updatedSimulationData.sort((a: any, b: any) => b.customer_num - a.customer_num);
          setOrignalSimulationData(updatedSimulationData);
          //Fi;tered data
          const clonedData: any = _.cloneDeep(updatedSimulationData);
          const filteredData: any = clonedData.filter((ele: any) => ele.customer_num !== "");

          setSimulationData(filteredData);

          if (updatedSimulationData.length <= 0) {
            setIsCustBelongToPG(true);
            setIsCustBelongToPGMessage("None of the material belongs to the customer.");
          }
        }
        setBackdropLoader(false);
      });
    }
    if (step === "submit_for_approval") {
      setBackdropLoader(true);
      handleSubmit();
    }
    setActiveStep((prev) => prev + 1);
  };
  const handleSubmit = async () => {
    const filteredData: any = simulationData.filter(
      (ele: any) => ele.customer_num !== "" && ele.isPriceChangeApplied === true
    );
    const response = await SubmitReviewDataForApproval(salesOrg, filteredData);

    if (response) {
      const resPriceChangeReqData = getPriceChangeRequestData(salesOrg);
    }
    setBackdropLoader(false);
    setOpenEditWindow(false);
    setActiveStep(0);
  };

  const handleBack = () => {
    setTrackToggle(true);
    setSimulationData([]);
    setActiveStep((prev) => prev - 1);
  };

  const handleWorkflowClose = () => {
    setOpenEditWindow(false);
    setActiveStep(0);
    setRecords([]);
  };

  const handleModalClose = () => {
    setOpenEditWindow(false);
    setOpenReqDetailsPopup(false);
  };

  const handleRejectClose = () => {
    setRejectPopup(false);
    setRejectMessage("");
  };

  useEffect(() => {
    if (doneLoading) return;
    //Implement API calling to get list of price change request
    let priceChangeGroups: any;
    let customerGroupList: any;
    let priceChangeReqData: any;
    Promise.all([
      getPriceChangePriceGroupsList(salesOrg).then((resPriceGroup) => {
        if (resPriceGroup) priceChangeGroups = resPriceGroup;
      }),
      getCustomerGroupList(salesOrg).then((resCustomerGroup) => {
        if (resCustomerGroup) customerGroupList = resCustomerGroup;
      }),
      requestMissingContexts(["BEVERAGECATEGORY", "PACKTYPE", "PACKSIZE", "BRAND"]).then((v) => {
        setCodes(v);
      }),
    ])
      .then(() => {
        setPriceGroupData(priceChangeGroups);
        setCustomerGroupData(customerGroupList);
        setDoneLoading(true);
      })
      .catch((error: any) => {
        setDoneLoading(true);
      });
    getPriceChangeRequestData(salesOrg);
  }, [doneLoading, priceChangeRequestsData, salesOrg]);

  const autoCompleteFilterOptions = createFilterOptions({
    matchFrom: "any",
    limit: 100, // 👈 Restricts the DOM to render a max of 100 items at a time
  });
  const getPriceChangeRequestData = (salesOrg: any) => {
    priceChangeRequestData(salesOrg).then((resPriceChangeReqData) => {
      if (resPriceChangeReqData) setPriceChangeRequestsData(resPriceChangeReqData);
    });
  };

  const handleAddTableData = () => {
    //Validations
    let alerMessage: string = "";
    if (!editRowCustGroupName || !editRowCustGroupName?.customer_num) {
      alerMessage = `Required! Plese Select  Customer/Customer group.`;
    } else if (!editedRowPriceGroup || !editedRowPriceGroup?.group_name) {
      alerMessage = `Required! Plese Select Price Group.`;
    } else if (editedRowVendPrice == "") {
      alerMessage = `Required! Plese Enter Valid Price`;
    }

    if (alerMessage !== "") {
      const alert = {
        alertTitle: "Alert",
        alertMessage: alerMessage,
        isAlertOpen: true,
        alertProceedButton: false,
        alertDenyButton: false,
        alertDisable: false,
      };
      setCommonAlert(alert);
      return;
    }

    const MatName = rowMaterial.material_num.material_num;
    const newRecord: TableRow = {
      editRowCustGroupName: editRowCustGroupName.customer_num.customer_num,
      editedRowPriceGroup: editedRowPriceGroup.group_name.group_name,
      rowMaterial: MatName,
      editedRowVendPrice,
      editedRowStartDate: editedRowStartDate.toLocaleString(),
      editedRowScheduleType,
    };

    setRecords((prev) => [...prev, newRecord]);
    setEditRowCustGroupName({ ...editRowCustGroupName, customer_num: "", name1: "" });
    setEditedRowPriceGroup({ ...editedRowPriceGroup, group_name: "" });
    setEditedRowVendPrice("");
    setEditedRowStartDate(new Date());
    setEditedRowScheduleType("Fill Key");
  };

  const handleTableDataDelete = (row: any) => {
    setRecords((prev) =>
      prev.filter(
        (item) =>
          !(
            item.editRowCustGroupName === row.editRowCustGroupName &&
            item.editedRowPriceGroup === row.editedRowPriceGroup &&
            item.rowMaterial === row.rowMaterial &&
            item.editedRowStartDate === row.editedRowStartDate
          )
      )
    );
  };
  const getPriceGroupsMaterial = (group_name: any) => {
    getMaterialsForPriceGroups(salesOrg, group_name.group_name).then((resMaterialList) => {
      if (resMaterialList) setPriceGroupMatrialList(resMaterialList);

      setRowMaterial((prev) => ({
        ...prev,
        material_num: {
          material_num: "ALL",
          description: "ALL",
        },
      }));
    });
  };
  const dynamicallyChooseColsForReqDetls: any = (params: any) => {
    //
    let columns: any = [
      {
        label: "Customer Num",
        name: "customer_num",
        options: {
          filter: true,
        },
      },
      {
        label: "Equipment Num",
        name: "equipment_num",
        options: {
          filter: true,
        },
        valueGetter: (props: any) => {
          return props?.row.equipment_num.replace(/^0+/, "");
        },
      },
      {
        label: "Material Num",
        name: "material_num",
        options: {
          filter: true,
        },
        valueGetter: (props: any) => {
          return props?.row.material_num.replace(/^0+/, "");
        },
      },
      {
        label: "Material Desc",
        name: "description",

        options: {
          filter: true,
        },
      },
      {
        label: "Product Group",
        name: "price_group",
        options: {
          filter: true,
        },
      },
      {
        label: "Pack Size",
        name: "pack_size",
        options: {
          filter: false,
          customBodyRender: (value: any) => `${determineConfigLong(codes, "PACKSIZE", value)}` || "",
        },
      },
      {
        label: "Pack Type",
        name: "pack_type",
        options: {
          filter: false,
          customBodyRender: (value: any) => `${determineConfigLong(codes, "PACKTYPE", value)}` || "",
        },
      },
      {
        label: "Beverage Category",
        name: "beverage_category",
        options: {
          filter: false,
          customBodyRender: (value: any) => `${determineConfigLong(codes, "BEVERAGECATEGORY", value)}` || "",
        },
      },
      {
        label: "Brand",
        name: "brand",
        options: {
          filter: false,
          customBodyRender: (value: any) => `${determineConfigLong(codes, "BRAND", value)}` || "",
        },
      },
      {
        label: "Vend Price - SAP",
        name: "price_cur",
        options: {
          filter: false,
          customBodyRender: (value: any) => (value != null ? (Number(value) / 100).toFixed(2) : "0.0"),
        },
      },
      {
        label: "Vend Price - DEX",
        name: "price_dex",
        options: {
          filter: false,
          customBodyRender: (value: any) => (value != null ? (Number(value) / 100).toFixed(2) : "0.0"),
        },
      },
      {
        label: "Vend Price -Proposed",
        name: "price_prop",
        options: {
          filter: false,
          customBodyRender: (value: any) => (value != null ? (Number(value) / 100).toFixed(2) : "0.0"),
        },
      },
    ];

    return columns;
  };

  const handleApprove = (currntval: any) => {
    // Call approve API
    handleApproval(currntval, "approve", salesOrg, "").then((response: any) => {
      getPriceChangeRequestData(salesOrg);
      setOpenReqDetailsPopup(false);
    });
  };
  const handleReject = (currntval: any) => {
    // Call reject API
    handleApproval(currntval, "reject", salesOrg, rejectMessage).then((response: any) => {
      getPriceChangeRequestData(salesOrg);
      setOpenReqDetailsPopup(false);
      setRejectMessage("");
      setRejectPopup(false);
    });
  };

  const handleChange = (event: any) => {
    if (!event.target.checked) {
      setSimulationData(orignalSimulationData);
    } else {
      const filteredData: any = orignalSimulationData.filter((ele: any) => ele.customer_num !== "");
      setSimulationData(filteredData);
    }
    setTrackToggle(event.target.checked);
  };

  return (
    <>
      <div className={classes.root}>
        {!openEditWindow ? (
          <>
            {doneLoading && enabled ? (
              <TableAbstraction
                settingsKey="ADM_OPT"
                options={{
                  draggableColumns: {
                    enabled: true,
                  },
                  rowsPerPageOptions: [25, 50, 100],
                  serverSide: false,
                  selectableRows: "none",
                  rowsPerPage: muiTable.rpp,
                  onChangeRowsPerPage: (numberOfRows) => {
                    setMuiTable((prev: any) => ({
                      ...prev,
                      rpp: numberOfRows,
                    }));
                  },
                  customToolbar: () => {
                    return (
                      <Tooltip title="New Price Request">
                        <IconButton
                          onClick={() => {
                            setActiveStep(0);
                            setRecords([]);
                            setOpenEditWindow(true);
                          }}
                        >
                          <AddIcon />
                        </IconButton>
                      </Tooltip>
                    );
                  },
                }}
                title="Price Change Requests"
                columns={[
                  {
                    label: "Requested On",
                    name: "created_at",
                    options: {
                      filter: true,
                      customBodyRender: (value) => formatDateTime(value),
                    },
                  },
                  {
                    label: "VS Price Request",
                    name: "request_id",
                    options: {
                      filter: true,
                      renderCell: (params) => (
                        <Link
                          component="button"
                          onClick={() => {
                            const filteredPriceChangeData: any = priceChangeRequestsData.filter(
                              (ele: any) => ele?.request_id.trim() == params?.value.trim()
                            );
                            const Reqstatus = filteredPriceChangeData[0]?.request_status || "";
                            const columns: any = dynamicallyChooseColsForReqDetls(params);
                            setApprovalHeader(`Approver View| Approve Request ${params.value}`);
                            setDynamicColsForReqDetls(columns);
                            setDynamicValforApproval(params.value);
                            setRequestDetailsPopupData(filteredPriceChangeData);
                            setRequestStatus(Reqstatus);
                            setOpenReqDetailsPopup(true);
                          }}
                        >
                          {params.value}
                        </Link>
                      ),
                    },
                  },
                  {
                    label: "Machine Price Request",
                    name: "change_req_id",
                    options: {
                      filter: true,
                    },
                  },
                  {
                    label: "Customer Group",
                    name: "cust_group",
                    options: {
                      searchable: true,
                      filter: false,
                      renderCell: (params) => (
                        <Link
                          component="button"
                          onClick={() => {
                            const filteredPriceChangeData: any = priceChangeRequestsData.filter(
                              (ele: any) => (ele?.cust_group ?? "").trim() == (params?.value ?? "").trim()
                            );
                            const Reqstatus = filteredPriceChangeData[0]?.request_status || "";
                            setRequestStatus(Reqstatus);
                            const columns: any = dynamicallyChooseColsForReqDetls(params);
                            setApprovalHeader(`Approver View| Approve Request for ${params.value}`);
                            setDynamicColsForReqDetls(columns);
                            setDynamicValforApproval(params.value);
                            setRequestDetailsPopupData(filteredPriceChangeData);
                            setOpenReqDetailsPopup(true);
                          }}
                        >
                          {params.value}
                        </Link>
                      ),
                    },
                  },
                  {
                    label: "Customer Num",
                    name: "customer_num",
                    options: {
                      filter: true,
                      renderCell: (params) => (
                        <Link
                          component="button"
                          onClick={() => {
                            const filteredPriceChangeData: any = priceChangeRequestsData.filter(
                              (ele: any) => ele?.customer_num.trim() == params?.value.trim()
                            );
                            const Reqstatus = filteredPriceChangeData[0]?.request_status || "";
                            setRequestStatus(Reqstatus);
                            const columns: any = dynamicallyChooseColsForReqDetls(params);
                            setApprovalHeader(`Approver View| Approve Request for ${params.value}`);
                            setDynamicColsForReqDetls(columns);
                            setDynamicValforApproval(params.value);
                            setRequestDetailsPopupData(filteredPriceChangeData);
                            setOpenReqDetailsPopup(true);
                          }}
                        >
                          {params.value}
                        </Link>
                      ),
                    },
                  },
                  {
                    label: "Name",
                    name: "customer_name",
                    options: {
                      filter: true,
                    },
                  },
                  {
                    label: "Equipment Num",
                    name: "equipment_num",
                    options: {
                      filter: false,
                    },
                    valueGetter: (props) => {
                      return props?.row.equipment_num.replace(/^0+/, "");
                    },
                  },
                  {
                    label: "Material Num",
                    name: "material_num",
                    options: {
                      filter: false,
                    },
                    valueGetter: (props) => {
                      return props?.row.material_num.replace(/^0+/, "");
                    },
                  },
                  {
                    label: "Material Desc",
                    name: "description",
                    options: {
                      filter: false,
                    },
                  },
                  {
                    label: "Product Group",
                    name: "price_group",
                    options: {
                      filter: false,
                    },
                  },
                  {
                    label: "Pack Size",
                    name: "pack_size",
                    options: {
                      filter: false,
                      customBodyRender: (value: any) => `${determineConfigLong(codes, "PACKSIZE", value)}` || "",
                    },
                  },
                  {
                    label: "Pack Type",
                    name: "pack_type",
                    options: {
                      filter: false,
                      customBodyRender: (value: any) => `${determineConfigLong(codes, "PACKTYPE", value)}` || "",
                    },
                  },
                  {
                    label: "Beverage Category",
                    name: "beverage_category",
                    options: {
                      filter: false,
                      customBodyRender: (value: any) =>
                        `${determineConfigLong(codes, "BEVERAGECATEGORY", value)}` || "",
                    },
                  },

                  {
                    label: "Brand",
                    name: "brand",
                    options: {
                      filter: false,
                      customBodyRender: (value: any) => `${determineConfigLong(codes, "BRAND", value)}` || "",
                    },
                  },
                  {
                    label: "Selectors Num",
                    name: "btn_num",
                    options: {
                      filter: false,
                    },
                  },
                  {
                    label: "Column Numbers",
                    name: "column_num",
                    options: {
                      filter: false,
                    },
                  },
                  {
                    label: "Vend Price - DEX",
                    name: "price_dex",
                    options: {
                      filter: false,
                      customBodyRender: (value: any) => (value != null ? (Number(value) / 100).toFixed(2) : "0.0"),
                    },
                  },
                  {
                    label: "Vend Price -Proposed",
                    name: "price_prop",
                    options: {
                      filter: false,
                      customBodyRender: (value: any) => (value != null ? (Number(value) / 100).toFixed(2) : "0.0"),
                    },
                  },
                  {
                    label: "VendPrice - Validated",
                    name: "price_cur",
                    options: {
                      filter: false,
                      customBodyRender: (value: any) => (value != null ? (Number(value) / 100).toFixed(2) : "0.0"),
                    },
                  },
                  {
                    label: "Requested By",
                    name: "created_by",
                    options: {
                      filter: false,
                    },
                  },
                  {
                    label: "Request Valid From",
                    name: "valid_from_dt",
                    options: {
                      filter: false,
                      customBodyRender: (value) => formatDateTime(value),
                    },
                  },
                  {
                    label: "Request Expiry",
                    name: "valid_to_dt",
                    options: {
                      filter: false,
                      customBodyRender: (value) => formatDateTime(value),
                    },
                  },
                  {
                    label: "Status",
                    name: "request_status",
                    options: {
                      filter: false,
                      customBodyRender: (value: any) => `${getRequestStatus(value)}` || "",
                    },
                  },
                  {
                    label: "Rejection Reason",
                    name: "reject_reason",
                    options: {
                      filter: false,
                    },
                  },
                  {
                    label: "Approved/ Rejected By",
                    name: "verified_by",
                    options: {
                      filter: false,
                    },
                  },
                  {
                    label: "Schedule Type",
                    name: "updt_on_fill",
                    options: {
                      filter: false,
                    },
                    valueGetter: (props) => {
                      return props?.row.updt_on_fill ? "Fill Key" : "Immediate";
                    },
                  },
                ]}
                data={priceChangeRequestsData}
              />
            ) : enabled ? (
              <div className={classes.centerDiv}>
                <CircularProgress color="primary" />
              </div>
            ) : (
              <Alert severity="error">
                <AlertTitle>
                  <LockIcon /> Access Error
                </AlertTitle>
                You do not currently have access to <strong>Admin</strong> activities for the{" "}
                <strong>{salesOrg}</strong> bottler.
              </Alert>
            )}
          </>
        ) : (
          <Box
            sx={{
              width: "100%",
              backgroundColor: "#fff",
              boxSizing: "border-box",
              p: 3,
            }}
          >
            <Stepper activeStep={activeStep} sx={{ mb: 4 }}>
              {steps.map((label) => (
                <Step key={label}>
                  <StepLabel>{label}</StepLabel>
                </Step>
              ))}
            </Stepper>

            {/* STEP 1 */}
            {activeStep === 0 && (
              <>
                {/* Move your current Price Request CardContent here */}

                <Card style={{ marginTop: "-7px" }}>
                  <CardContent>
                    <Grid container spacing={1} className={classes.modalGrid} alignItems="flex-start">
                      <Grid item xs="auto" md="auto" xl="auto">
                        <InputLabel>Cust/Group</InputLabel>
                        <Autocomplete
                          options={customerGroupData || []}
                          sx={{ width: 450 }}
                          filterOptions={autoCompleteFilterOptions}
                          value={editRowCustGroupName.customer_num}
                          getOptionLabel={(option: any) =>
                            `${option?.customer_num ? option?.customer_num + "-" + option?.name1 : ""}`
                          }
                          isOptionEqualToValue={(option, value) => option?.customer_num === value?.customer_num}
                          onChange={(_, newValue) => {
                            setEditRowCustGroupName({
                              ...editRowCustGroupName,
                              customer_num: newValue,
                            });
                          }}
                          renderInput={(params) => <TextField {...params} />}
                        />
                      </Grid>
                      <Grid item xs="auto" md="auto" xl="auto">
                        <InputLabel>Price Group Name</InputLabel>
                        <Autocomplete
                          options={priceGroupData || []}
                          sx={{ width: 450 }}
                          value={editedRowPriceGroup.group_name}
                          getOptionLabel={(option) => option?.group_name || ""}
                          isOptionEqualToValue={(option, value) => option?.group_name === value?.group_name}
                          onChange={(_, newValue) => {
                            setEditedRowPriceGroup({
                              ...editedRowPriceGroup,
                              group_name: newValue,
                            });
                            getPriceGroupsMaterial(newValue);
                          }}
                          onKeyDown={(event) => {
                            if (event.key === "Enter" && (event.target as any).value) {
                              const newValue = (event.target as any).value;
                              setEditedRowPriceGroup({ ...editedRowPriceGroup, group_name: newValue });
                              getPriceGroupsMaterial(newValue);
                            }
                          }}
                          renderInput={(params) => <TextField {...params} />}
                        />
                      </Grid>
                    </Grid>
                    <Grid container spacing={1} className={classes.modalGrid} alignItems="flex-start">
                      <Grid item xs={"auto"} md={"auto"} xl={"auto"}>
                        <InputLabel>Materials</InputLabel>
                        <Autocomplete
                          options={materialOptions}
                          sx={{ width: 450 }}
                          value={rowMaterial.material_num}
                          getOptionLabel={(option) => option?.description || ""}
                          isOptionEqualToValue={(option, value) => option?.material_num === value?.material_num}
                          onChange={(_, newValue) => {
                            setRowMaterial({
                              ...rowMaterial,
                              material_num: newValue,
                            });
                          }}
                          onKeyDown={(event) => {
                            if (event.key === "Enter" && (event.target as any).value) {
                              const newValue = (event.target as any).value;
                              setRowMaterial({ ...rowMaterial, material_num: newValue });
                            }
                          }}
                          renderInput={(params) => <TextField {...params} />}
                        />
                      </Grid>
                      <Grid item xs={"auto"} md={"auto"} xl={"auto"}>
                        <InputLabel>VendPrice</InputLabel>
                        <TextField
                          placeholder="VendPrice"
                          type="text"
                          className={classes.modalInput}
                          value={editedRowVendPrice}
                          onChange={(e) => {
                            setEditedRowVendPrice(
                              e.target.value && typeof e.target.value == "string" ? e.target.value : ""
                            );
                          }}
                          InputProps={{
                            startAdornment: <InputAdornment position="start">$</InputAdornment>,
                          }}
                        ></TextField>
                      </Grid>
                      <Grid item xs={"auto"} md={"auto"} xl={"auto"}>
                        <InputLabel>Start Date</InputLabel>
                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                          <DateTimePicker
                            value={editedRowStartDate}
                            onChange={(newValue) => {
                              if (newValue) {
                                setEditedRowStartDate(newValue);
                              }
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                variant="standard"
                                className={classes.modalInput}
                                sx={{
                                  mt: -0.5,
                                }}
                              />
                            )}
                          />
                        </LocalizationProvider>
                      </Grid>
                      <Grid item xs={"auto"} md={"auto"} xl={"auto"}>
                        <InputLabel>Schedule Type</InputLabel>

                        <Select
                          label="Schedule Type"
                          value={editedRowScheduleType}
                          className={classes.modalInput}
                          onChange={(e) => setEditedRowScheduleType(e.target.value)}
                        >
                          <MenuItem value="Fill Key">Fill Key</MenuItem>
                          <MenuItem value="Immediate">Immediate</MenuItem>
                        </Select>
                      </Grid>
                      <Grid item xs={"auto"} md={"auto"} xl={"auto"} marginLeft={10}>
                        <Button
                          color="primary"
                          variant="contained"
                          className={classes.paragraphButton}
                          onClick={handleAddTableData}
                        >
                          + Add
                        </Button>
                      </Grid>
                    </Grid>

                    <Grid container spacing={1} className={classes.modalGrid}>
                      <Grid item xs={"auto"} md={12} xl={12} style={{ height: "450px" }}>
                        <Card>
                          <TableAbstraction
                            settingsKey="ADM_BN"
                            options={{
                              draggableColumns: {
                                enabled: true,
                              },
                              serverSide: false,
                              selectableRows: "none",
                              tableBodyHeight: "470px",
                            }}
                            title="Price Change Request"
                            columns={[
                              // salesOffice:string, bankID: string, bankName: string, customerNum:string, change:string
                              {
                                label: "Customer",
                                name: "editRowCustGroupName",
                                options: {
                                  filter: true,
                                  customBodyRender: (value: any) => (value ? `${value}` : ""),
                                },
                              },
                              {
                                label: "Price Group",
                                name: "editedRowPriceGroup",
                                options: {
                                  searchable: true,
                                  filter: false,
                                },
                              },
                              {
                                label: "Material",
                                name: "rowMaterial",
                                options: {
                                  searchable: true,
                                  filter: false,
                                },
                                valueGetter: (props) => {
                                  return props?.row.rowMaterial.replace(/^0+/, "");
                                },
                              },
                              {
                                label: "Vend Price -Proposed",
                                name: "editedRowVendPrice",
                                options: {
                                  searchable: true,
                                  filter: false,
                                  customBodyRender: (value: any) => {
                                    const price = Number(value);

                                    if (isNaN(price)) {
                                      return "$0.00";
                                    }

                                    return `$${price.toFixed(2)}`;
                                  },
                                },
                              },
                              {
                                label: "Start Date",
                                name: "editedRowStartDate",
                                options: {
                                  searchable: true,
                                  filter: false,
                                },
                              },
                              {
                                label: "Schedule",
                                name: "editedRowScheduleType",
                                options: {
                                  searchable: true,
                                  filter: false,
                                },
                              },
                              {
                                label: "Delete",
                                name: "name2",
                                options: {
                                  filter: false,
                                  renderCell: (params) => {
                                    return (
                                      <React.Fragment>
                                        <Tooltip title={"Delete"}>
                                          <DeleteIcon
                                            fontSize="small"
                                            onClick={() => {
                                              handleTableDataDelete(params.row);
                                            }}
                                          />
                                        </Tooltip>
                                      </React.Fragment>
                                    );
                                  },
                                },
                              },
                            ]}
                            data={records}
                          />
                        </Card>
                      </Grid>
                    </Grid>
                  </CardContent>
                </Card>

                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "flex-end",
                    mt: 3,
                    gap: 1,
                  }}
                >
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={() => handleNext("proceed_to_review")}
                    disabled={records.length === 0}
                  >
                    Proceed to Review
                  </Button>

                  <Button variant="outlined" onClick={handleWorkflowClose}>
                    Cancel
                  </Button>
                </Box>
              </>
            )}

            {/* STEP 2 */}
            {activeStep === 1 && (
              <>
                <Card style={{ marginTop: "-15px" }}>
                  <Button variant="outlined" onClick={handleBack}>
                    Back
                  </Button>
                  <CardContent>
                    <TableAbstraction
                      settingsKey="ADM_BN"
                      options={{
                        draggableColumns: {
                          enabled: true,
                        },
                        tableBodyHeight: "500px",
                        serverSide: false,
                        selectableRows: "none",
                        customToolbar: () => {
                          return (
                            <>
                              <Tooltip title="Show Belonging Customer Only">
                                <Switch checked={trackToggle} onChange={handleChange} />
                              </Tooltip>
                              <span style={{ color: "gray" }}>
                                When ON, shows list of materials which belongs to a Price Group & the customers.
                                <br />
                                Turn OFF to see list of all matrials inside the Price Group{" "}
                              </span>
                            </>
                          );
                        },
                      }}
                      title="Review Screen | Price Simulation"
                      columns={[
                        {
                          label: "Price Change Applied?",
                          name: "isPriceChangeApplied",
                          options: {
                            searchable: true,
                            filter: false,
                            customBodyRender: (value: any) => {
                              if (value) {
                                return (
                                  <>
                                    <Tooltip title="Price Change Applied">
                                      <AttachMoneyIcon color="success" />
                                    </Tooltip>
                                  </>
                                );
                              } else {
                                return (
                                  <>
                                    <Tooltip title="Price Change Not Applied">
                                      <MoneyOffIcon color="error" />
                                    </Tooltip>
                                  </>
                                );
                              }
                            },
                          },
                        },
                        {
                          label: "Customer Num",
                          name: "customer_num",
                          options: {
                            filter: true,
                          },
                        },
                        {
                          label: "Equipment Num",
                          name: "equipment_num",
                          options: {
                            searchable: true,
                            filter: false,
                          },
                          valueGetter: (props) => {
                            return props?.row.equipment_num.replace(/^0+/, "");
                          },
                        },
                        {
                          label: "Material Num",
                          name: "material_num",
                          options: {
                            searchable: true,
                            filter: false,
                          },
                          valueGetter: (props) => {
                            return props?.row.material_num.replace(/^0+/, "");
                          },
                        },
                        {
                          label: "Material Desc",
                          name: "description",
                          options: {
                            searchable: true,
                            filter: false,
                          },
                        },
                        {
                          label: "Price Group",
                          name: "price_group",
                          options: {
                            searchable: true,
                            filter: false,
                          },
                        },
                        {
                          label: "Pack Size",
                          name: "pack_size",
                          options: {
                            searchable: true,
                            filter: false,
                          },
                        },
                        {
                          label: "Pack Type",
                          name: "pack_type",
                          options: {
                            searchable: true,
                            filter: false,
                          },
                        },
                        {
                          label: "Beverage Category",
                          name: "beverage_category",
                          options: {
                            searchable: true,
                            filter: false,
                          },
                        },
                        {
                          label: "Brand",
                          name: "brand",
                          options: {
                            searchable: true,
                            filter: false,
                          },
                        },
                        {
                          label: "Vend Price - SAP",
                          name: "price",
                          options: {
                            searchable: true,
                            filter: false,
                            customBodyRender: (value: any) => (value ? (Number(value) / 100).toFixed(2) : "0.0"),
                          },
                        },
                        {
                          label: "Vend Price - DEX",
                          name: "dex_price",
                          options: {
                            searchable: true,
                            filter: false,
                            customBodyRender: (value: any) => (value ? (Number(value) / 100).toFixed(2) : "0.0"),
                          },
                        },
                        {
                          label: "Vend Price -Proposed",
                          name: "price_proposed",
                          options: {
                            searchable: true,
                            filter: false,
                            customBodyRender: (value: any) =>
                              value !== null && value !== undefined ? Number(value).toFixed(2) : "0.00",
                          },
                        },
                        {
                          label: "Error Details",
                          name: "errorDetails",
                          options: {
                            searchable: true,
                            filter: false,
                          },
                        },
                      ]}
                      data={simulationData}
                    />
                  </CardContent>
                </Card>

                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    mt: 3,
                  }}
                >
                  <Button variant="outlined" onClick={handleBack}>
                    Back
                  </Button>

                  <Box sx={{ display: "flex", gap: 1 }}>
                    <Button variant="outlined" onClick={handleWorkflowClose}>
                      Cancel
                    </Button>

                    <Button
                      variant="contained"
                      color="primary"
                      disabled={
                        simulationData.some((row: any) => row.errorDetails?.trim()) ||
                        !simulationData.some((row: any) => row.customer_num !== "")
                      }
                      onClick={() => handleNext("submit_for_approval")}
                    >
                      Submit For Approval
                    </Button>
                  </Box>
                </Box>
              </>
            )}
          </Box>
        )}{" "}
        {/* Confirmation dialog */}
        <Dialog open={confirmDelete} onClose={() => setConfirmDelete(false)}>
          ...
        </Dialog>
        {/* Feature Coming Soon Popup */}
        <Dialog
          open={comingSoonPopup}
          onClose={() => {
            setComingSoonPopup(false);
          }}
          maxWidth="xs"
          fullWidth
          PaperProps={{
            sx: {
              borderRadius: 4,
              padding: 2,
              textAlign: "center",
              position: "relative",
              overflow: "visible", // Allows visual elements to slightly overlap if needed
            },
          }}
        >
          {/* Close Button top-right */}
          <IconButton
            aria-label="close"
            onClick={() => {
              setComingSoonPopup(false);
            }}
            sx={{
              position: "absolute",
              right: 16,
              top: 16,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>

          <DialogContent sx={{ pt: 4, pb: 2 }}>
            {/* Animated/Styled Icon Container */}
            <Box
              sx={{
                display: "inline-flex",
                backgroundColor: "primary.lightest", // Customize with your theme values
                bgcolor: "action.hover",
                p: 3,
                borderRadius: "50%",
                mb: 3,
              }}
            >
              <RocketIcon sx={{ fontSize: 50, color: "primary.main" }} />
            </Box>

            {/* Heading & Copy */}
            <Typography variant="h5" component="h2" fontWeight="700" gutterBottom>
              Feature Coming Soon!
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 4, px: 2 }}>
              We are hard at work building this feature to improve your experience.
            </Typography>
          </DialogContent>
        </Dialog>
        {/* Material Details popup */}
        <Dialog
          open={openReqDetailsPopup}
          onClose={handleModalClose}
          PaperProps={{
            sx: {
              width: "100%", // Overrides default width behavior
              maxWidth: "1800px", // Prevents it from getting too wide
            },
          }}
        >
          <DialogTitle>
            <IconButton
              onClick={handleModalClose}
              sx={{
                position: "absolute",
                right: 8,
                top: 0,
              }}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>

          <DialogContent>
            <TableAbstraction
              settingsKey="ADM_BN"
              options={{
                draggableColumns: {
                  enabled: true,
                },
                serverSide: false,
                selectableRows: "none",
                tableBodyHeight: "690px",
              }}
              title={approvalHeader}
              columns={dynamicColsForReqDetls}
              data={requestDetailsPopupData}
            />
          </DialogContent>
          {reqStatus === "RP_QUEUE" && (
            <DialogActions>
              <Button variant="contained" color="success" onClick={() => handleApprove(dynamicValforApproval)}>
                Approve
              </Button>

              <Button variant="contained" color="error" onClick={() => setRejectPopup(true)}>
                Reject
              </Button>
            </DialogActions>
          )}
        </Dialog>
        {/* Page common alert message popup */}
        <Dialog open={commonAlert.isAlertOpen} onClose={() => setCommonAlert({ ...commonAlert, isAlertOpen: false })}>
          <DialogTitle>{commonAlert.alertTitle}</DialogTitle>
          <DialogContent>
            <DialogContentText>{commonAlert.alertMessage}</DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => {
                setCommonAlert({ ...commonAlert, isAlertOpen: false });
              }}
              color="primary"
              autoFocus
            >
              Ok
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog
          open={rejectPopup}
          onClose={handleRejectClose}
          PaperProps={{
            sx: {
              height: "300px",
              width: "500px",
            },
          }}
        >
          <DialogTitle>Rejection Message</DialogTitle>
          <DialogContent>
            <TextField
              sx={{
                "& .MuiInputBase-root": {
                  height: 130, // Set your custom height here
                },
              }}
              autoFocus
              margin="dense"
              label="Your Message"
              type="text"
              fullWidth
              variant="outlined"
              multiline
              maxRows={3}
              value={rejectMessage}
              onChange={(e) => setRejectMessage(e.target.value)}
            />
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => {
                handleReject(dynamicValforApproval);
              }}
              variant="contained"
            >
              Reject
            </Button>
            <Button onClick={handleRejectClose} variant="contained">
              Close
            </Button>
          </DialogActions>
        </Dialog>
      </div>
      <Backdrop
        sx={{
          color: "#fff",
          zIndex: (theme) => Math.max.apply(Math, Object.values(theme.zIndex)) + 1,
        }}
        open={backdropLoader}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </>
  );
}
